function Footer(props){
    return(
        <div className="Footer">
            
           <p>Created by: Sarrthi Jasrotia, Neil Saunders, Matt Porter</p>
        </div>
    )
}

export default Footer;